module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Double-check-695a6c115d6c9b98954d8c4e3e86f1ee.svg";